var _g, _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaseCreatedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 202,
    viewBox: "0 0 202 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_0_1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 87,
    r: 62,
    fill: "url(#paint0_linear_0_1)",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 75.2383,
    y: 71.6572,
    width: 43.4504,
    height: 19.7749,
    rx: 9.88743,
    transform: "rotate(45 75.2383 71.6572)",
    fill: "url(#paint1_linear_0_1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.589 95.9989L76.4908 97.0882C82.3889 98.3989 88.4504 95.6988 91.421 90.4375C92.0325 89.3545 92.7883 88.3597 93.6677 87.4802L118.531 62.6168C122.392 58.7556 128.653 58.7556 132.514 62.6168C136.375 66.4781 136.375 72.7385 132.514 76.5998L96.4447 112.669C94.0865 115.027 90.2578 115.01 87.9211 112.63L71.589 95.9989Z",
    fill: "url(#paint2_linear_0_1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_0_1",
    x: 0,
    y: 0,
    width: 202,
    height: 202,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.174928 0 0 0 0 0.174928 0 0 0 0 0.174928 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_0_1",
    result: "effect2_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 101,
    y1: 25,
    x2: 101,
    y2: 149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 117.718,
    y1: 83.0554,
    x2: 73.0282,
    y2: 81.8022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DCF57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BD263"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 95.0715,
    y1: 72.5164,
    x2: 115.834,
    y2: 93.2794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53DD6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44C95C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseCreatedIcon);
export default __webpack_public_path__ + "static/media/case_created_icon.9792388f1bdd708b02ad6c9a430bdcbe.svg";
export { ForwardRef as ReactComponent };